import React, {Component} from 'react';
import ItemList from '../ItemList';
import {Button, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import GreenLeafApi from '../utils/GreenLeafApi';

class UserList extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      error: null,
      isLoading: true,
      users: []
    };
  }

  async componentDidMount() {
    try {
      const users = await GreenLeafApi.User.list();
      this.setState({ users: users, isLoading: false });
    } catch (e) {
      console.error(e);
    }
  }

  deleteUser = async (user) => {
    try {
      await GreenLeafApi.User.delete(user.email);
      const users = await GreenLeafApi.User.list();
      this.setState({ users });
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading...</p>;
    }
    
    if (this.state.error) {
      return <p>{this.state.error}</p>;
    }
    
    const userData = this.state.users.map(u => ({
      email: u.Username,
      id: u.Username,
      role: (u.Attributes.find(a => a.Name === 'custom:role') || {}).Value
    }));

    return (
      <div>
        <Panel>
          <Panel.Heading>
            <div className={'table-header'}>
              <Panel.Title componentClass="h3">Users</Panel.Title>
              <Link to={'/users/create'}><Button data-cy="create-user" className={'primary'}>Create</Button></Link>
              <Link to={'/users/invite'} style={{ marginLeft: '5px' }}><Button data-cy="invite-user" className={'primary'}>Invite</Button></Link>
            </div>
          </Panel.Heading>
          <Panel.Body>
            <ItemList
              options={{
                tableHeaders: ['Username', 'Role'],
                tableData: ['email', 'role'],
                editItem: (user) => this.props.history.push({ pathname: '/users/edit', state: { email: user.email }}),
                deleteItem: this.deleteUser
              }}
              items={userData}/>
            
          </Panel.Body>
        </Panel>
      </div>
    );
  }

}

UserList.propTypes = {};

export default UserList;



// WEBPACK FOOTER //
// ./src/components/user/UserList.js